import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import {
  TextAreaItem,
  InputItem,
  DatePickerItem,
} from "../../../components/forms/FormItems";
import { EmployeesSelect } from "../../../components/forms/AutoCompleteFormItem";
import { createPersonalFileComment } from "../employeePersonalFileSlice";
import { useSelector } from "react-redux";
import AddEntityForm from "../../../components/templates/AddEntityForm";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";

const AddEmployeePersonalFile = (props) => {
  const { hide, addText, mode, record, activeEmployee } = props;
  let { branchId } = useParams();
  let location = useLocation();

  const dispatch = useDispatch();
  const createLoading = useSelector(
    (state) => state.pendingActions["employeePersonalFile/create"]
  );
  const isAdmin = location.pathname.includes("admin");
  const branch_id = isAdmin
    ? activeEmployee.branch_active[0].branch_id
    : branchId;
  const onFinish = async (values) => {
    const params = {
      branchId: branch_id,
      employeeId: activeEmployee.id,
      personalFileComment: values,
    };
    const action = await dispatch(createPersonalFileComment(params));
    if (!action.error) {
      hide();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };
  const staffFilter = { $and: [{ staff_member: true }] };

  const items = [
    {
      name: "title",
      required: true,
      comp: <InputItem name="title" category="personal_file" required={true} />,
    },
    {
      name: "comment",
      required: true,
      comp: (
        <TextAreaItem
          rows={8}
          name="comment"
          category="personal_file"
          required={true}
        />
      ),
    },
    {
      name: "executed_at",
      required: true,
      comp: (
        <DatePickerItem
          name="executed_at"
          category="personal_file"
          required={true}
          format={"L"}
        />
      ),
    },
    {
      name: "reported_by_id",
      comp: (
        <EmployeesSelect
          name="reported_by_id"
          category="personal_file"
          waitForFetch={!activeEmployee || !branch_id}
          extraParams={{
            filter: staffFilter,
            scopePrefix: isAdmin ? `/` : `branches/${branchId}/`,
          }}
        />
      ),
    },
  ];

  return (
    <AddEntityForm
      formLayout={{
        labelCol: { span: 7 },
        wrapperCol: { span: 17 },
      }}
      resource="employees"
      action="editor"
      activeEntity={record}
      items={items}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onDecline={onDecline}
      saveLoading={createLoading}
      addText={addText}
      mode={mode}
      initialValues={{ executed_at: moment() }}
    />
  );
};

AddEmployeePersonalFile.propTypes = {
  hide: PropTypes.func,
  addText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default AddEmployeePersonalFile;
